<template>
  <v-container class="mx-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card
          flat
          :class="cardClasses"
          v-if="Object.keys(barrier).length != 0"
        >
          <v-tabs v-model="activeTab" class="selected-tab-custom">
            <template v-for="tab in filterTabs()">
              <template v-if="tab.show && isDisplayInfoBarrier">
                <v-tab :key="tab.name" class="custom-tab" :disabled="tab.isDisabled">
                  {{ tab.name }}
                </v-tab>
                <v-tab-item :key="tab.name" class="tab-item" :class="{'color-change' : hasFlatCard }">
                  <component v-bind:is="tab.component" v-bind="tab.props"/>
                </v-tab-item>
              </template>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GeneralInfo from './components/GeneralInfo.vue';
import JournalGrz from './components/JournalGrz';
import ListAbonents from './components/ListAbonents';
import ListCarNumbers from './components/ListCarNumbers';
import ListTemporaryAbonents from './components/ListTemporaryAbonents';
import MobileBarrierOpening from './components/MobileBarrierOpening';
import WhitePhoneNumbers from './components/WhitePhoneNumbers';

export default {
  name: 'DetailBarrier',
  props: ['id'],
  data () {
    return {
      disableRoleName: true,
      isDisplayInfoBarrier: true,
      hasFlatCard: true,
      isDisabled: false,
      totalAccounts: null,
      totalNumberCars: null,
      totalTemporarySubscribers: null,
      totalWhitePhoneNumbers: null,
      activeTab: 0,
      resComplexName: [],
      responseTemporaryAbonents: [],
      filterAbonents: {},
      filterTemporaryAbonents: {},
    };
  },
  watch: {
    activeTab: {
      handler: function (after, before) {
        this.updateFlatCard();
        if (after === 1 || after === 2) {
          this.loadBarrierWithCarNumbers();
        }
      },
      deep: true,
    },
  },
  async created () {
    this.isDisplayInfoBarrier = false;
    if (this.roleName !== 'master') {
      this.getResidentialComplex()
        .then((data) => {
          this.resComplexName = data.data;
        })
        .catch((error) => {
          console.error('Ошибка при получении данных:', error);
        });
    }
    this.getBarrier({
      id: this.id,
    })
      .then(() => {
        this.isDisplayInfoBarrier = true;
        if (this.roleName !== 'master') {
          this.countingAbonents();
          if (this.barrier.device && this.barrier.device.model !== 'RACS-1101') {
            this.getTemporaryAbonents();
          }
          this.getWhitePhoneNumbersCount();
        }
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации');
      });
    if (this.barrier.status_condition === null && this.barrier.sip_status === '2' && this.barrier.device) {
      this.getStatusCondition({
        id: this.id,
      });
    }
  },

  computed: {
    ...mapGetters({
      roleName: 'roleName',
      barrier: 'Barriers/barrier',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'DetailBarrierNewGeneralInfo',
          show: true,
          props: {
            resComplexName: this.resComplexName,
            totalAccounts: this.totalAccounts,
            totalNumberCars: this.barrier.car_numbers_count || 0,
            totalTemporarySubscribers: this.totalTemporarySubscribers,
            totalWhitePhoneNumbers: this.totalWhitePhoneNumbers,
          },
          isDisabled: false,
        },
        {
          name: 'Список абонентов',
          component: ListAbonents,
          route: 'BarriersListAbonents',
          show: true,
          props: {
            barrier: this.barrier,
            responseCars: this.barrier.car_numbers || [],
          },
          isDisabled: false,
        },
        {
          name: 'Номера автомобилей',
          component: ListCarNumbers,
          route: 'BarriersListCarNumbers',
          show: true,
          props: {
            barrier: this.barrier,
            resComplexName: this.resComplexName,
            responseCars: this.barrier.car_numbers || [],
          },
          isDisabled: this.isBarrierDisabled || this.isBarrierDevice,
        },
        {
          name: 'Временные абоненты',
          component: ListTemporaryAbonents,
          route: 'BarriersListTemporaryAbonents',
          show: true,
          props: {
            barrier: this.barrier,
            resComplexName: this.resComplexName,
            responseTemporaryAbonents: this.responseTemporaryAbonents,
            getData: this.getTemporaryAbonents,
          },
          isDisabled: this.isBarrierDisabled || this.isBarrierDevice,
        },
        {
          name: 'Белый список',
          component: WhitePhoneNumbers,
          route: 'BarriersWhitePhoneNumbers',
          show: true,
          props: {
            barrier: this.barrier,
          },
          isDisabled: false,
        },
        {
          name: 'Журнал ГРЗ',
          component: JournalGrz,
          route: 'BarriersJournalGrz',
          show: true,
          isDisabled: this.isBarrierDisabled || this.isBarrierDevice,
        },
        {
          name: 'Журнал открытия',
          component: MobileBarrierOpening,
          route: 'MobileBarrierOpening',
          show: true,
          isDisabled: false,
        },
      ];
    },
    isBarrierDevice () {
      return this.barrier && this.barrier.device && this.barrier.device.model !== 'DS07P-LP';
    },
    isBarrierDisabled () {
      // старый шлагбаум
      return this.barrier.physical_status === 5;
    },
    cardClasses () {
      return {
        'pb-5': true,
        'border-card': true,
        'color-change': this.hasFlatCard,
      };
    },
  },
  methods: {
    ...mapActions({
      getBarrier: 'Barriers/getBarrier',
      getStatusCondition: 'Barriers/getStatusCondition',
      getResidentialComplex: 'ResidentComplex/getComplex',
      loadTemporaryAbonents: 'TemporaryAbonent/loadTemporaryAbonents',
      loadAbonents: 'Abonents/loadAbonents',
      getWhitePhoneNumbers: 'Barriers/getWhitePhoneNumbers',
    }),
    updateFlatCard () {
      this.hasFlatCard = this.activeTab === 0;
    },
    async getTemporaryAbonents () {
      this.filterTemporaryAbonents.barriers = this.barrier.id;
      this.loadTemporaryAbonents({
        filters: this.filterTemporaryAbonents,
      })
        .then((data) => {
          this.responseTemporaryAbonents = data;
          this.totalTemporarySubscribers = data.length;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке временных абонентов');
          }
        });
    },
    countingAbonents () {
      const doorphoneIds = this.barrier.doorphones.map(doorphone => doorphone.id);

      if (doorphoneIds.length === 0) {
        this.$flash_danger('Нет привязанных домофонов');
        return;
      }
      this.filterAbonents.doorphone_id = doorphoneIds.join(',');
      this.loadAbonents({
        pagination: 1,
        limit: 15,
        filters: this.filterAbonents,
      })
        .then((data) => {
          this.totalAccounts = data.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке кол-во абонентов');
        });
    },
    async getWhitePhoneNumbersCount () {
      try {
        const response = await this.getWhitePhoneNumbers({ barrierId: this.barrier.id });
        this.totalWhitePhoneNumbers = response.data ? response.data.length : 0;
      } catch (error) {
        console.error('Ошибка при загрузке количества номеров белого списка:', error);
        this.totalWhitePhoneNumbers = 0;
      }
    },
    loadBarrierWithCarNumbers () {
      if (Array.isArray(this.barrier.car_numbers)) return;
      this.getBarrier({
        id: this.id,
        includes: ['car_numbers'],
      }).catch(() => {
        this.$flash_warning('Ошибка при загрузке информации о госномерах');
      });
    },
    filterTabs () {
      return this.tabs.filter(tab => {
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tab {
  border: 1px solid #C5C9CF;
  border-radius: 16px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.v-tab {
  background-color: #E7E3E3;
}
v-tab:before {
  background-color: #E7E3E3;
  color: black;
}
.v-tab.v-tab--active {
  background-color: white;
  color: black;
}
.color-change {
  background-color: #F5F5F5;
}
.v-tab--active.v-tab:not(:focus) {
  border-radius: 16px;
}
.v-tab--active.v-tab:not(:focus)::before {
  border-radius: 16px;
}
.border-card {
  border-radius: 16px;
}
</style>
